import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Indicator} from '../models/indicator.model';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IndicatorService {

  private api:string = environment.api+'/indicators';

  constructor(private http: HttpClient) { }


  public updateIndicator(indicator:Indicator){
    return this.http.put(this.api,indicator);
  }
}
